import axios from 'axios';
import { getAuthHeader } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export interface UserProfile {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  phoneCountryCode?: string;
  photo?: string;
  emailVerified: boolean;
  phoneVerified: boolean;
  userType: string;
  // Provider-specific fields
  specialization?: string;
  licenseNumber?: string;
  // Student-specific fields
  schoolId?: string;
  address?: string;
  studyProgram?: string;
  gender?: string;
  dateOfBirth?: string;
  school?: string;
  race?: string;
  // Admin-specific fields
  adminType?: string;
}

export interface UpdateProfileRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  phoneCountryCode?: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

class ProfileService {
  async getProfile(): Promise<UserProfile> {
    const response = await axios.get(`${API_BASE_URL}/profile`, {
      headers: getAuthHeader()
    });
    return response.data;
  }

  async updateProfile(data: UpdateProfileRequest): Promise<{ message: string }> {
    const response = await axios.put(`${API_BASE_URL}/profile`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  }

  async changePassword(data: ChangePasswordRequest): Promise<{ message: string }> {
    const response = await axios.post(`${API_BASE_URL}/profile/change-password`, data, {
      headers: getAuthHeader()
    });
    return response.data;
  }

  async uploadPhoto(photo: File): Promise<{ message: string; photoUrl?: string }> {
    const formData = new FormData();
    formData.append('photo', photo);
    
    const response = await axios.post(`${API_BASE_URL}/profile/upload-photo`, formData, {
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
}

export default new ProfileService();